import client from './client';
import { Store, StoreOrderType } from '../types';

export const getStores = async (sellerId?: string): Promise<Store[]> => {
    const url = sellerId ? `stores?sellerId=${sellerId}` : 'stores';
    const response = await client.get(url);
    return response.data;
};

export const getStoreById = async (id: string): Promise<Store> => {
    const response = await client.get(`stores/${id}`);
    return response.data;
};

export const createStore = async (
  name: string,
  options?: {
    slug?: string | null;
    description?: string;
    orderType?: StoreOrderType;
    deliveryTime?: string;
    deliverySchedule?: string;
    defaultDeliveryDay?: number;
    sellerId?: string;
    operationDayOfWeeks?: number[];
    operationStartHour?: number;
    operationEndHour?: number;
    pickupUnmannedStartHour?: number | null;
    pickupUnmannedLabel?: string | null;
    supportsArrivalDateFilter?: boolean;
    acceptsPickupTime?: boolean;
    acceptsRequestMessage?: boolean;
    acceptsOrderEdit?: boolean;
  },
) => {
    const response = await client.post('stores/admin', { name, ...options });
    return response.data;
};

export const updateStore = async (id: string, updates: Partial<Store>) => {
    const response = await client.patch(`stores/admin/${id}`, updates);
    return response.data;
};

export const deleteStore = async (id: string) => {
    const response = await client.delete(`stores/admin/${id}`);
    return response.data;
};

export const getDeletedStores = async (): Promise<Store[]> => {
    const response = await client.get('stores/admin/deleted');
    return response.data;
};

export const restoreStore = async (id: string) => {
    const response = await client.post(`stores/admin/${id}/restore`);
    return response.data;
};

export const reorderStores = async (ids: string[]) => {
    const response = await client.patch('stores/admin/reorder', { ids });
    return response.data;
};
